( () => {

	/**
	 * Block name
	 *
	 * @type {string}
	 */
	const blockName = 'image-text';

	/**
	 * Init
	 */
	window.addEventListener( 'load', () => {

		const blocks = document.querySelectorAll( `.block-${ blockName }` );
		if ( blocks.length > 0 ) {

			blocks.forEach( ( block ) => {

				initializeBlock( block );

			} );

		}

	} );

	/**
	 * Block init
	 *
	 * @param {Object} block
	 */
	const initializeBlock = ( block ) => {

		if ( block[ 0 ] !== undefined ) {

			block = block[ 0 ].querySelector( `.block-${ blockName }` );

		}
		if ( block === false || block === null ) {
		}

		// Block Code Here

	};

} )();
